import React from 'react';
import ControlPlaneLayout from './ControlPlaneLayout';

const DisputesPage = () => {
  return (
    <ControlPlaneLayout
      eyebrow="Disputes Page"
      title="Disputes and review"
      description="Escalate low-confidence resolutions, missing anchors, and other cases that require operator intervention."
    />
  );
};

export default DisputesPage;
